<template>
  <div class="row mt-1 d-flex justify-content-around">
    <div
      class="btn btn-sm btn-primary position-relative"
      style="width: 20%"
      @click="updateStore('transact')"
    >
      Transact
      <span
        class="position-absolute top-0 start-100 translate-middle p-2"
        v-if="store.action == 'transact'"
      >
        <i class="bi bi-x-lg text-danger"></i>
      </span>
    </div>
    <div
      class="btn btn-sm btn-warning position-relative"
      style="width: 20%"
      @click="updateStore('attendance')"
      v-if="attendanceAccountExists"
    >
      Hazari
      <span
        class="position-absolute top-0 start-100 translate-middle p-2"
        v-if="store.action == 'attendance'"
      >
        <i class="bi bi-x-lg text-danger"></i>
      </span>
    </div>
    <div
      class="btn btn-sm btn-info position-relative"
      style="width: 20%"
      @click="updateStore('note')"
    >
      Note
      <span
        class="position-absolute top-0 start-100 translate-middle p-2"
        v-if="store.action == 'note'"
      >
        <i class="bi bi-x-lg text-danger"></i>
      </span>
    </div>
    <!-- <div
      class="btn btn-sm btn-success position-relative"
      style="width: 20%"
      @click="updateStore('updateaccounts')"
    >
      Accts
      <span
        class="position-absolute top-0 start-100 translate-middle p-2"
        v-if="store.action == 'updateaccounts'"
      >
        <i class="bi bi-x-lg text-danger fw-bold"></i>
      </span>
    </div> -->
  </div>
</template>
<script setup>
import { useStore } from "../../store/index";
import { updateDoc, doc } from "firebase/firestore";
import { auth, db } from "../../firebase/config";
import { ref, computed } from "vue";
const store = useStore();
const updateStore = async (action) => {
  const userDocRef = doc(db, "users", auth.currentUser.uid);
  if (store.action != action) {
    await updateDoc(userDocRef, {
      "settings.action": action,
    });
  } else {
    await updateDoc(userDocRef, {
      "settings.action": "",
    });
  }
};
const attendanceAccountExists = computed(() => {
  var exists = false;
  store.accounts.forEach((a) => {
    if (a.attendance) {
      exists = true;
    }
  });
  return exists;
});
</script>
